export * from './module';
export * from './shared';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/metadata/index.ts